import { FaCalculator, FaChartLine, FaHandHoldingUsd, FaPuzzlePiece } from "react-icons/fa";
import "../../styles/entreprenuership.css";

const entrepreneurshipData = {
  introduction: "The Entrepreneurship Education program is designed to equip individuals with the skills and knowledge needed to thrive in the business world. From local community initiatives to global ventures, our curriculum covers a wide range of entrepreneurial challenges and opportunities.",
  certifications: [
    { title: "Local Entrepreneurship", description: "Focused on solving local community challenges through entrepreneurship." },
    { title: "National Entrepreneurship", description: "Develops skills to address entrepreneurial needs on a national scale." },
    { title: "Continental Entrepreneurship", description: "Training for continent-wide business challenges and solutions." },
    { title: "Global Entrepreneurship", description: "Prepares students for international business and problem-solving." }
  ],
  modules: [
    { title: "Practical Accounting", description: "Teaches intuitive financial principles, removing complexity in accounting language.", icon: <FaCalculator size={40} /> },
    { title: "Practical Economics", description: "Develops economic thinking through real-world application.", icon: <FaChartLine size={40} /> },
    { title: "Art of Investment", description: "Instills the philosophy of sowing before reaping—understanding delayed returns.", icon: <FaHandHoldingUsd size={40} /> },
    { title: "Optimization", description: "Focuses on efficient problem-solving across multiple disciplines.", icon: <FaPuzzlePiece size={40} /> }
  ]
};

const Entreprenuership = () => {
  return (
    <div className="entrepreneurship">
      <h1>Entrepreneurship Education</h1>
      
      {/* Introduction Section */}
      <section className="intro">
        <p>{entrepreneurshipData.introduction}</p>
      </section>

      <section className="certifications">
        <h2>Entrepreneurship Certifications</h2>
        <div className="certifications-grid">
          {entrepreneurshipData.certifications.map((cert, index) => (
            <div key={index} className="cert-card">
              <h3>{cert.title}</h3>
              <p>{cert.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="modules">
        <h2>Major Modules</h2>
        <div className="modules-grid">
          {entrepreneurshipData.modules.map((mod, index) => (
            <div key={index} className="module-card">
              {mod.icon}
              <h3>{mod.title}</h3>
              <p>{mod.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Entreprenuership;
